/**
 * DispositionBar - what a social test suggests for how somebody stands,
 * on the screen that ran the test.
 *
 * One line per person: the reason, and - when it would change anything -
 * the move by name; or leave them as they are. Nobody's disposition moves
 * unasked. Draws nothing when nothing is proposed.
 *
 * @param {object} props
 * @param {object} props.dispositions - hooks/useDispositionProposals
 */
import common from '../../styles/common.module.css';
import styles from '../../styles/CallForTest.module.css';

function Proposal({ proposal, dispositions }) {
  return (
    <div className={styles.callLine} data-testid="disposition-proposal">
      <span>
        {proposal.name}: {proposal.reason}
      </span>
      {proposal.moves && (
        <button
          type="button"
          className={common.btnDodge}
          data-testid="disposition-accept"
          onClick={() => dispositions.accept(proposal.targetId)}
        >
          Make them {proposal.disposition}
        </button>
      )}
      <button
        type="button"
        className={common.btnSmall}
        data-testid="disposition-leave"
        onClick={() => dispositions.leave(proposal.targetId)}
      >
        {proposal.moves ? 'Leave them as they are' : 'Done'}
      </button>
    </div>
  );
}

export default function DispositionBar({ dispositions }) {
  if (dispositions.proposals.length === 0) return null;
  return (
    <div className={styles.calls} role="status" data-testid="disposition-bar">
      {dispositions.proposals.map((proposal) => (
        <Proposal key={proposal.targetId} proposal={proposal} dispositions={dispositions} />
      ))}
    </div>
  );
}
